import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';

import {
  CropSection,
  SoilSection,
  StatusSection,
  ResetButton,
} from './components';
import { useGermanStatusBoard } from './hooks/useGermanStatusBoard';
import { SoilPhSection } from './components/SoilPhSection';

export const GermanStatusBoard = () => {
  const {
    currentYield,
    setCurrentYield,
    initialCurrentYield,
    getErrorOfCurrentYield,
    mtHa,
    secSmol,
    setSecSmol,
    initialSecSmol,
    errorSecSmol,
    fineDrySoil,
    setFineDrySoil,
    handleFineDrySoil,
    kg,
    currentSec,
    setCurrentSec,
    currentSecAuto,
    errorCurrentSecHandle,
    targetSec,
    errorTargetSec,
    resetData,
    isGreaterTarget,
    getMthaText,
    getMtha,
  } = useGermanStatusBoard();

  const { isExpertMode } = useCroptimizer();

  return (
    <>
      <div className="border border-primitiveGrey p-8 md:py-4 md:px-4 rounded-2xl">
        <CropSection
          currentYield={currentYield}
          setCurrentYield={setCurrentYield}
          initialCurrentYield={initialCurrentYield}
          getErrorOfCurrentYield={getErrorOfCurrentYield}
          mtHa={mtHa}
        />

        <SoilSection
          secSmol={secSmol}
          setSecSmol={setSecSmol}
          initialSecSmol={initialSecSmol}
          errorSecSmol={errorSecSmol}
          fineDrySoil={fineDrySoil}
          setFineDrySoil={setFineDrySoil}
          handleFineDrySoil={handleFineDrySoil}
          kg={kg}
        />

        <StatusSection
          currentSec={currentSec}
          setCurrentSec={setCurrentSec}
          currentSecAuto={currentSecAuto}
          errorCurrentSecHandle={errorCurrentSecHandle}
          targetSec={targetSec}
          errorTargetSec={errorTargetSec}
        />

        <SoilPhSection
          isGreaterTarget={isGreaterTarget}
          getMthaText={getMthaText}
          getMtha={String(getMtha)}
          isExpertMode={isExpertMode}
        />

        <ResetButton resetData={resetData} />
      </div>
    </>
  );
};
